module.exports = __webpack_public_path__ + "img/shell.07ec9245.png";